export default __webpack_public_path__ + "static/media/user-quad.93cc519e.png";